export default "__VITE_ASSET__k8wc5ehB__";